import '../index.css'
import * as React from 'react'
import { useContext } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { isMobile } from 'react-device-detect'
import { PlusOutlined } from '@ant-design/icons'
import { PageProps } from '../'
import { InfoCxt } from '../../../App'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

interface SpecialPlanDataType {
  drugName: string
  dose: string
  type: string
  allSchedules: string[]
  creator?: string
  plans: {
    id: string
    creationDate: string
    dosage: number
    perDay: number
    schedules: string[]
    reminder: boolean
    reminderTime: string[]
  }[]
}

const columns: ColumnsType<SpecialPlanDataType> = [
  { title: 'Medication Name', dataIndex: 'drugName' },
  { title: 'Dosage', dataIndex: 'dose' },
  { title: 'Type', dataIndex: 'type' },
  { title: 'Creator', render: () => 'Patient' },
  { title: 'Action', width: '116px', render: () => null },
]

/* -------------------------------- react fc -------------------------------- */

const Plan: React.FC<PageProps> = () => {
  const { showComingSoon } = useContext(InfoCxt)

  return (
    <>
      <TabHeader border>
        <PageTitle text='Medications' />
        <Button type='primary' ghost icon={<PlusOutlined />} onClick={showComingSoon}>
          {isMobile ? null : 'Add'}
        </Button>
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Medication Plan' />
        <TableBox>
          <Table columns={columns} dataSource={[]} rowKey={(record) => record.drugName} pagination={false} />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export type { SpecialPlanDataType }
export default Plan
